<template>
	<v-app-bar app dark>
		<slot name="left">
			<v-app-bar-nav-icon @click.native.stop="back">
				<v-icon>fa-arrow-left</v-icon>
			</v-app-bar-nav-icon>
		</slot>
		<v-spacer />
		<slot name="center">
			<v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
		</slot>
		<v-spacer />
		<slot name="right">
			<v-btn icon @click="exit">
				<v-icon>fa-home</v-icon>
			</v-btn>
		</slot>
	</v-app-bar>
</template>

<script>
import _ from "lodash";

export default {
	props: {
		title: {
			type: String,
			required: false,
			default: undefined,
		},
		backFn: {
			type: Function,
			required: false,
			default: undefined,
		},
		exitFn: {
			type: Function,
			required: false,
			default: undefined,
		},
	},

	computed: {
		toolbarTitle() {
			if (this.title) return this.title;
			return this.$route.meta.title || this.$route.name || "";
		},
	},

	methods: {
		back(event) {
			if (this.backFn) this.backFn(event);

			// Default behavior: Check route for "back" metadata and push it to
			// router. Otherwise use default browser back button behavior.
			const routeDesc = _.get(this.$route, "meta.back");
			if (routeDesc) return this.$router.push(routeDesc);
			else return this.$router.back();
		},

		exit(event) {
			if (this.exitFn) {
				return this.exitFn(event);
			}

			// Default behavior: Go home.
			return this.$router.push({ name: "Home" });
		},
	},
};
</script>
